// Import local icon images
import cppIcon from '../images/IconImages/cpp.svg';
import pythonIcon from '../images/IconImages/python.svg';
import javascriptIcon from '../images/IconImages/javascript.svg';
import mysqlIcon from '../images/IconImages/mysql.svg';
import opencvIcon from '../images/IconImages/opencv.svg';
import nodejsIcon from '../images/IconImages/nodejs.svg';
import postgresqlIcon from '../images/IconImages/postgresql.svg';
import openaiIcon from '../images/IconImages/openai.svg';
import fastapiIcon from '../images/IconImages/fastapi.svg';
import restIcon from '../images/IconImages/rest.png';
import mongodbIcon from '../images/IconImages/mongodb.svg';
import redshiftIcon from '../images/IconImages/redshift.svg';
import snowflakeIcon from '../images/IconImages/snowflake.svg';
import powerbiIcon from '../images/IconImages/powerbi.png';
import githubIcon from '../images/IconImages/github.png';
import awsIcon from '../images/IconImages/aws.svg';
import kaliIcon from '../images/IconImages/kali.svg';
import excelIcon from '../images/IconImages/excel.png';
import salesforceIcon from '../images/IconImages/salesforce.svg';
import stMarysSchoolIcon from '../images/IconImages/StMarySchool.png';
import hevoDataIcon from '../images/IconImages/HevoData.png';
import highRadiusIcon from '../images/IconImages/HighRadius.png';
import tataSteelIcon from '../images/IconImages/TataSteel.png';
import ernstYoungIcon from '../images/IconImages/ErnstYoung.png';

export const Bio = {
  name: "Sriyans Ghose",
  roles: [
    "Developer",
    "Data Analyst",
    "Web Designer",
    "ML Enthusiast",
    "Cybersecurity Enthusiast",
  ],
  description:
    "I'm a passionate software developer and data engineer with 2+ years of experience in building scalable data models and pipelines, financial analytics dashboards, and AI-powered platforms. Skilled in SQL, DBT, Snowflake, Redshift, and AWS. Beyond data, I am a photographer with hobbies in 3D rendering and tool devA, continuously learning and delivering impactful, growth-driven solutions."
  ,
  github: "https://github.com/sriyansg",
  resume:
    "https://www.linkedin.com/in/sriyansg/",
    linkedin: "https://www.linkedin.com/in/sriyansg/",
  // twitter: "https://twitter.com",
  // insta: "https://www.instagram.com",
  // facebook: "https://www.facebook.com/",
};
// Category Descs:
// Vision/Fun Apps
// machine learning
// web app
export const skills = [
  {
    title: "Coding Frameworks",
    skills: [
      {
        name: "C++",
        image: cppIcon,
      },
      {
        name: "Python",
        image: pythonIcon,
      },

      {
        name: "JavaScript",
        image: javascriptIcon,
      },
      {
        name: "MySQL",
        image: mysqlIcon,
      },
      {
        name: "OpenCV",
        image: opencvIcon,
      },
      {
        name: "Node Js",
        image: nodejsIcon,
      },
      {
        name: "PostgreSQL",
        image: postgresqlIcon,
      },
      {
        name: "OpenAI API",
        image: openaiIcon,
          
      },{
        name: "FastAPI",
        image: fastapiIcon,
      },{
        name: "REST API",
        image: restIcon,
      },
    ],
  },
  {
    title: "Softwares",
    skills: [
      {
        name: "MongoDB",
        image: mongodbIcon,
      },
      {
        name: "Amazon Redshift",
        image: redshiftIcon,
      },
      {
        name: "Snowflake",
        image: snowflakeIcon,
      },
      {
        name: "PowerBI",
        image: powerbiIcon
      },
      {
        name: "GitHub",
        image: githubIcon,
      },
      {
        name: "AWS",
        image: awsIcon
      },
      
      {
        name: "Kali Linux",
        image: kaliIcon      
      },
      {
        name: "Excel",
        image: excelIcon
      },
      {
        name: "Salesforce",
        image: salesforceIcon
      },
    ],
  },
];

export const experiences = [
  {
    id: 0,
    img: hevoDataIcon,
    role: "Data Engineer | Business Analyst | GTM AI Engineer",
    company: "Hevo Data",
    date: "March 2024 - Present",
    desc: `• Engineered cross-platform data pipelines integrating HubSpot (CRM) and Stripe (financial transactions), enabling a unified view of revenue metrics, churn, and product-sales activity. Leading financial analytics to indentify gaps and achieve timely actionable insights for the stakeholders<br/><br/>• Designed and deployed an internal Reverse ETL Tool allowing analysts to query Redshift and sync datasets to HubSpot with AI-driven fuzzy field mapping, reducing manual effort by 70% and dependency on CRM admins.<br/><br/>• Built and scaled an LLM-powered SEO performance dashboard (React, FastAPI, PostgreSQL), tracking competitor citations and ranking in ChatGPT and enabling real-time analytics for GTM teams.<br/><br/>• Implemented a semantic AI query engine converting natural language to optimized SQL, reducing analytics turnaround time from hours to minutes.<br/><br/>• Optimized ETL workflows across multiple SaaS platforms (Stripe, Zendesk, HubSpot) improving reporting accuracy by 45%.`,
    skills: [
      "PostgresSQL",
      "Finance Analytics",
      "OpenAI SDK",
      "ELT Pipelines",
      "Snowflake",
      "Redshift",
    ],
  },
  {
    id: 1,
    img: highRadiusIcon,
    role: "Technical Consulting Intern",
    company: "HighRadius Corporation",
    date: "July 2023 - Oct 2023",
    desc: "Worked in the Credit team of Order-to-Cash (O2C) cycle, emphasizing credit management and optimizing credit evaluations, and understanding client requirements, proficient in SQL data analysis and Excel spreadsheet management.",
    skills: [
      "Excel Data Analysis",
      "Credit O2C",
      "ERP Software",
      "Client-Interaction",
      "SQL",
    ],
  },
  {
    id: 2,
    img: tataSteelIcon,
    role: "Artificial Intelligence Intern",
    company: "Tata Steel Limited",
    date: "May 2023 – July 2023",
    desc: "Worked on enhancing efficiency and productivity within the steel industry by leveraging generative AI models.",
    skills: [
      "Machine Learning",
      "OpenAI Api",
      "Image Detection",
      "Stable Diffusion",
    ],
  },
  {
    id: 3,
    img: ernstYoungIcon,
    role: "Cybersecurity Intern",
    company: "Ernst & Young",
    date: "June 2023 - July 2023",
    desc: "Acquired practical skills with cybersecurity tools, analyzing security measures. Cultivated foundational Pen Testing and network vulnerability skills through hands-on experience with Nessus and Nmap."
    ,
    skills: [
      "Cybersecurity",
      "Nessus",
      "Nmap",
      "Penetration Testing",
      "Kali Linux",
    ],
  },

];

export const education = [
  {
    id: 0,
    img: "https://firebasestorage.googleapis.com/v0/b/flexi-coding.appspot.com/o/Kiit.jpeg?alt=media&token=3839d520-c59d-4341-ad8f-0980c98de4dd",
    school: "Kalinga Institute of Industrial Technology, Bhubaneswar",
    date: "2020-2024",
    grade: "8.76 CGPA",
    desc: "Data Structures, OOP, Computer Networking, Artificial Intelligence, Operating Systems, DBMS",
    degree: "Bachelor of Technology - BTech, Computer Science and Engineering",
  },
  {
    id: 1,
    img: stMarysSchoolIcon,
    school: "St.Mary's School ICSE, Mumbai",
    date: "Apr 2017 - Apr 2019",
    grade: "93.4%",
    desc: "Recieved Solomon Aptekar Scholarship for Excellence in Computer Applications.",
    degree: "ICSC(X), Science with Computer",
  },
];

export const projects = [
  {
    id: 0,
    title: "Expense Tracker App",
    date: "2023",
    description:
      "Designed and implemented a MERN stack application for expense tracking, incorporating income, expenses, category management, and dynamic visual analytics for user financial data.",
    image: "https://github.com/sriyansg/expense-tracker/blob/main/ExpenseDemo.png?raw=true",
    tags: [
      "ReactJs",
      "Express",
      "NodeJS",
      "MongoDB",
      "ChartJS",
      "Axios",
    ],
    category: "web app",
    github: "https://github.com/sriyansg/expense-tracker",
    webapp: "https://github.com/sriyansg/expense-tracker",
  },
  {
    id: 1,
    title: "Hoodify",
    date: "2021",
    description:
      "Created a Functional Spotify Clone using front-end Webdev,It has the ability to play, pause and skip songs from a playlist and adjust the music playing volume.",
    image:
      "https://github.com/sriyansg/Hoodify/blob/main/hoodify%20img.png?raw=true",
    tags: [
      "HTML",
      "CSS",
      "Javascript",

    ],
    category: "web app",
    github: "https://github.com/sriyansg/Hoodify",
    webapp: "https://sriyansg.github.io/Hoodify/",
  },
  {
    id: 3,
    title: "Zomato Data Analysis",
    date: "2022",
    description:
      "Conducted comprehensive exploratory data analysis on a large-scale Zomato dataset, meticulously cleaning and examining the data to extract valuable insights into the restaurant industry.",
    image:
      "https://github.com/sriyansg/Zomato-EDA/blob/main/zom.png?raw=true",
    tags: ["Python", "JupyterNB", "Numpy", "Pandas","Seabord","Matplotlib"],
    category: "machine learning",
    github: "https://github.com/sriyansg/Zomato-EDA",
    webapp: "https://github.com/sriyansg/Zomato-EDA",
  },
  {
    id: 10,
    title: "Fake News Detector",
    date: "2022",
    description:
      "Analyzing data from fake news dataset to discover trends, correlations, and probabilities, employed logistic regression as the primary algorithm for detecting fabricated news.",
    image:
      "https://github.com/sriyansg/Fake-News-Predictor-ML/blob/master/fakenews.png?raw=true",
    tags: ["Python", "NumPy", "Pandas","re","SkLearn","NLTK"],
    category: "machine learning",
    github: "https://github.com/sriyansg/Fake-News-Predictor-ML",
    webapp: "https://github.com/sriyansg/Fake-News-Predictor-ML",
  },
  {
    id: 4,
    title: "COVID-19 Detection using CNN from X-RAYS",
    date: "2023",
    description:
      "Analyzing Images to detect possible Covid Cases. Led data preprocessing, refining a diverse dataset by removing noise from X-Ray image. Trained the CNN model with optimization techniques, achieving an outstanding accuracy rate.",
    image:
      "",
    tags: ["Python", "TensorFlow", "NumPy", "ReLU"],
    category: "machine learning",
    github: "",
    webapp: "",
  },
  {
    id: 5,
    title: "Face Mask Detection",
    date: "2022",
    description:
      " Using the YOLO to develop a model to detect the number of people wearing masksin public.",
    image:"https://cdn.discordapp.com/attachments/970751089504825365/1185624856717430894/11554_2023_1353_Fig9_HTML.png?ex=65904a31&is=657dd531&hm=c0c0ae083c8d76136f279ba4259c9a46158a38c9c29ab70fa456611f8bb84b63&",
    tags: ["Python", "YOLOv5", "OpenCV",],
    category: "Vision/Fun Apps",
    github: "",
    webapp: "",
  },
  {
    id: 6,
    title: "Intrusion Detector",
    date: "2023",
    description:
      "A simple Image detection program built using python and opencv that detects any movement in camera frame, can be used for real life applications.",
    image:
      "https://github.com/sriyansg/Intrusion-Detection-V1/blob/main/Intrusion.png?raw=true",
    tags: ["Python", "OpenCV"],
    category: "Vision/Fun Apps",
    github: "https://github.com/sriyansg/Intrusion-Detection-V1",
    webapp: "https://github.com/sriyansg/Intrusion-Detection-V1",
  },
];
